// SC-199: a stable per-device identifier so the QR-scan throttle (sale_api) can
// rate-limit per person instead of per NAT'd restaurant IP. Sent as the
// X-Client-Id header on table-session resolve/join. Persisted in localStorage so
// it survives refreshes and tab closes (unlike the per-order idempotency key,
// which is intentionally per-session).

const CLIENT_ID_KEY = 'ouitap:client-id';

function randomId(): string {
  // crypto.randomUUID needs a secure context; fall back for plain-http dev.
  return typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
    ? crypto.randomUUID()
    : `client-${Date.now()}-${Math.random().toString(36).slice(2)}`;
}

/**
 * Returns this device's stable client id, generating and persisting one on first
 * use. Degrades gracefully to a fresh (non-persisted) id if localStorage is
 * unavailable (private mode / blocked storage) so requests still carry a header.
 */
export function getClientId(): string {
  try {
    const existing = localStorage.getItem(CLIENT_ID_KEY);
    if (existing) return existing;
    const value = randomId();
    localStorage.setItem(CLIENT_ID_KEY, value);
    return value;
  } catch {
    return randomId();
  }
}
